import React, { useMemo } from 'react';

import {
  Text, Box, Center, BadgeProps,
} from '@chakra-ui/react';

import { Icon } from 'components/icon';
import { statusType } from 'constants/badgeTypes';

interface StatusBadgeProps extends BadgeProps{
  status: keyof typeof statusType
  small?:boolean
  iconPosition?:'left'| 'right'
  label?:string
  iconName?:string
}

export default function StatusBadge({
  status,
  small,
  iconPosition = 'left',
  iconName,
  label,
  ...rest
}: StatusBadgeProps) {
  if (!status) {
    return null;
  }
  const {
    color, bg, label: statusLabel, ...box
  } = useMemo(() => statusType[status], [status]);

  function HandleIcon(props) {
    if (!iconName) {
      return null;
    }
    return (
      <Icon
        color={color}
        family="fas"
        size={small ? '3xs' : '2xs'}
        name={iconName}
        {...props}
      />
    );
  }

  return (
    <Box
      borderRadius="100px"
      w="fit-content"
      display="flex"
      align="center"
      bg={bg}
      px={2}
      minH={6}
      py={small && 1}
      {...box}
      {...rest}>
      <Center
        px={1}
        align="center"
        justify="center">
        {iconPosition === 'left' && <HandleIcon mr={2} />}
        <Text
          variant={small ? '2xSmallSemiBold' : 'xSmallSemiBold'}
          color={color}>
          {label || statusLabel}
        </Text>
        {iconPosition === 'right' && <HandleIcon ml={2} />}
      </Center>
    </Box>
  );
}
